import { Component, AfterViewInit, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Observable ,  Subscription  } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { ApiError, AuthService, ConfigService, MessageService } from '../../../../../core';
import { BaseTypeahead, BaseTypeaheadService } from '../../../../../core/services/typeahead';
import { ConfigEmpresa, createNomeRepresentante } from '../../../../configuracoes/app/empresa';
import { Cliente } from '../../cliente';
import { ClienteFilter } from '../../filter/cliente-filter';
import { isClienteCadastroCliente } from '../../cadastro';
import { isClienteSituacaoAtivo } from '../../situacao';
import { ClienteTypeahead } from '../../typeahead/cliente-typeahead';
import { TypeaheadClienteHttpService } from '../../typeahead/typeahead-cliente-http.service';
import { ClienteSearchesHttpService } from '../../services';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

@Component({
    selector: 'sgt-cliente-central-compra-typeahead',
    templateUrl: './cliente-central-compra-typeahead.component.html',
    styleUrls: ['./cliente-central-compra-typeahead.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ClienteCentralCompraTypeaheadComponent), multi: true },
    ]
})
export class ClienteCentralCompraTypeaheadComponent implements OnInit, AfterViewInit, BaseTypeahead<Cliente> {
    configEmpresa: ConfigEmpresa;
    isRepresentante: boolean;

    @Input() entity: Cliente;
    @Output() ngModelChange = new EventEmitter<Cliente>();

    /** Cadastro */
    @Input() somenteClientesEmCarteira: boolean = null; // Somente os clientes em carteira (clientes com cadastro igual a cliente)
    @Input() somenteClientesEmCarteiraAtiva: boolean = null; // Somente os clientes em carteira (clientes com cadastro igual a cliente) que estão com situação igual a Ativo
    @Input() somenteClientesEmCarteiraInativa: boolean = null; // Somente os clientes em carteira (clientes com cadastro igual a cliente) que estão com situação igual a Inativo
    @Input() somenteClientes: boolean = null; // Somente os clientes com cadastro igual a Cliente
    @Input() somenteClientesCongelados: boolean = null; // Somente os clientes com cadastro congelado
    @Input() somenteClientesBloqueados: boolean = null; // Somente os clientes com cadastro bloqueado
    @Input() somenteClientesBaixados: boolean = null; // Somente os clientes com cadastro baixado
    @Input() somenteClientesOutros: boolean = null; // Somente os clientes com cadastro Outros
    @Input() cadastros: number[] = []; // Cadastros considerados no filtro

    /** Situação */
    @Input() somenteClientesAtivos: boolean = null; // Somente os clientes com a situação ativo
    @Input() somenteClientesInativos: boolean = null; // Somente os clientes com a situação inativo
    @Input() situacoes: number[] = []; // Situações consideradas no filtro

    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() ngControl: NgControl;
    @Input() autofocus = false;
    @Input() container = '';
    @Input() dropup = false;
    @Input() typeaheadOptionsInScrollableView = 5; // Quantidade de itens visíveis no no scroll do typeahead
    @Output() typeaheadChange = new EventEmitter<Cliente>();
    @Output() entitySelected = new EventEmitter<Cliente>(); // Emite evento quando a entidade foi selecionada no typeahead
    @Output() clearEntity = new EventEmitter<any>();

    @ViewChild('inputTypeahead', {static: true}) inputTypeahead: ElementRef;
    typeaheadOptionsLimit = 1000; // Quantidade máxima de registros exibidos no typeahead
    typeaheadSelected: string;
    typeaheadToken: string;
    typeaheadDataSource: Observable<Cliente[]>;
    typeaheadNoResults: boolean;

    currentRequest: Subscription;
    isLoading: boolean;

    propagateChange: any = () => {};

    constructor(private authService: AuthService,
                private configService: ConfigService,
                private baseTypeaheadService: BaseTypeaheadService,
                private messageService: MessageService,
                private typeaheadClienteHttpService: TypeaheadClienteHttpService,
                private clienteSearchesHttpService: ClienteSearchesHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isRepresentante = this.authService.isRepresentante();

        this.createDataSource();
    }

    ngAfterViewInit() {
        if (this.autofocus) {
            jQuery(this.inputTypeahead.nativeElement).trigger('focus');
        }
    }

    /** Cria o filtro para pesquisar os clientes */
    private createFilter(): ClienteFilter {
        const filter = new ClienteFilter();
        // Nome / Código Integração / CNPJ/CPF
        filter.filterPsq = this.typeaheadToken;

        /** Cadastro */
        filter.somenteClientesEmCarteira = this.somenteClientesEmCarteira;
        filter.somenteClientesEmCarteiraAtiva = this.somenteClientesEmCarteiraAtiva;
        filter.somenteClientesEmCarteiraInativa = this.somenteClientesEmCarteiraInativa;
        filter.somenteClientes = this.somenteClientes;
        filter.somenteClientesCongelados = this.somenteClientesCongelados;
        filter.somenteClientesBloqueados = this.somenteClientesBloqueados;
        filter.somenteClientesBaixados = this.somenteClientesBaixados;
        filter.somenteClientesOutros = this.somenteClientesOutros;
        filter.cadastros = this.cadastros;

        /** Situação */
        filter.somenteClientesAtivos = this.somenteClientesAtivos;
        filter.somenteClientesInativos = this.somenteClientesInativos;
        filter.situacoes = this.situacoes;

        // Somente central de compra
        filter.somenteCentralDeCompra = true;

        return filter;
    }

    /** Cria o data source do typeahead */
    createDataSource() {
        this.typeaheadDataSource = Observable.create((observer: any) => {
            if (this.currentRequest) {
                this.currentRequest.unsubscribe();
            }

            const filter = this.createFilter();
            this.currentRequest = this.typeaheadClienteHttpService.search(filter, this.typeaheadOptionsLimit)
                                        .subscribe(
                                            (entities: ClienteTypeahead[]) => observer.next(entities),
                                            (error: ApiError) => {
                                                this.messageService.error(error.message, 'Ocorreu um erro ao pesquisar as centrais de compras. Tente novamente', error);
                                                observer.next([]);
                                            }
                                        );
        }).pipe(
          map((clientes: ClienteTypeahead[]) => {
              clientes.forEach(entity => {
                  entity.nomeRepresentante = createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, entity.nomeRepresentante, entity.nomeFantasiaRepresentante);
              });

              return clientes;
          })
        );
    }


    /** Ao digitar no input do typeahead */
    onKeyup(e: KeyboardEvent) {
        this.baseTypeaheadService.onKeyup(this, e);
    }

    /** Ao sair do input do typeahead */
    onBlur() {
        this.baseTypeaheadService.onBlur(this);
        if (!this.entity) {
            this.clearEntity.emit();
        }
    }

    /** Verifica se o typeahead possui resultados */
    onChangeTypeaheadNoResults(noResults: boolean) {
        this.typeaheadNoResults = noResults;
    }

    /** Carrega o cliente informado para o Typeahead */
    private load(idCliente: number): Promise<ClienteTypeahead> {
        return new Promise<ClienteTypeahead>((resolve, reject) => {
            this.typeaheadClienteHttpService.load(idCliente)
                .pipe(
                    take(1)
                )
                .subscribe(
                    cliente => resolve(cliente),
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar a central de compras', error);
                        reject();
                    }
                );
        });
    }


    /** Seta o cliente informado no typeahead */
    setEntity(idCliente: number) {
        this.load(idCliente)
            .then(cliente => {
                this.selectEntity(cliente as any);
            })
            .catch(() => {});
    }

    /** Seleciona o cliente no typeahead */
    private selectEntity(cliente: Cliente) {
        this.entity = cliente ?? null;

        this.propagateChange(this.entity);
        this.typeaheadChange.emit(this.entity);
        this.entitySelected.emit(this.entity);
        this.writeValue(this.entity);
        jQuery(this.inputTypeahead.nativeElement).trigger('focus');
    }

    /** Ao selecionar o cliente no typeahead */
    onSelectEntity(tm: TypeaheadMatch) {
        const cliente = tm.item as Cliente;
        this.baseTypeaheadService.onSelectEntity(this, tm);
        this.entitySelected.emit(this.entity);
    }

    /** Limpa o typeahead e o model */
    clear() {
        this.baseTypeaheadService.clear(this);
        this.clearEntity.emit();
    }

    /** Seta o foco no input */
    setFocus() {
        jQuery(this.inputTypeahead.nativeElement).trigger('focus');
    }


   /** Quando recebe um objeto Cliente de "fora" do component */
    writeValue(value: Cliente) {
        if (value) {
            this.baseTypeaheadService.writeValue(this, value, value.pessoa.nome);

            // Obtendo a cidade e estado do cliente para exibir no template
            this.getCidadeEstadoCliente(value.id);
        } else {
            this.baseTypeaheadService.writeValue(this, null);
        }
    }

    /** Propaga as alterações */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    /** Obtem o nome da cidade e estado do cliente */
    private getCidadeEstadoCliente(idCliente: number) {
        this.clienteSearchesHttpService.getCidadeEstado(idCliente)
            .subscribe(
                entity => {
                    if (entity) {
                        this.entity.nomeCidade = entity.nomeCidade;
                        this.entity.uf = entity.uf;
                    }
                },
                (() => {})
            );
    }

    /** Verifica se é um cliente com cadastro igual a Cliente */
    isClienteCadastroCliente(cadastro: number): boolean {
        return isClienteCadastroCliente(cadastro);
    }

    /** Verifica se é um cliente com situação ativo */
    isClienteSituacaoAtivo(situacao: number): boolean {
        return isClienteSituacaoAtivo(situacao);
    }
}
